/**
 * @file BackupLocalFolder.tsx
 * @description Папка локальных копий в «Где хранить копии» (phase19.26 шаг 7.1,
 * Р1) — только для чтения.
 *
 * Папку задаёт команда установки (блок «Установка на сервере»), панель её не
 * меняет: показывает то, что прислал агент (`localRoot`), а до первого отчёта —
 * подсказку, где она задаётся. Ниже — предупреждение, что копия на том же
 * диске не защищает от его отказа (совет выбрать внешнее хранилище — только
 * когда оно доступно).
 */

import { FolderOpen } from "lucide-react";

import { NoticeStrip } from "../../ui/NoticeStrip";

interface Props {
  localRoot: string | null;
  /** Внешние хранилища доступны (`externalDestinationsEnabled`). */
  externalEnabled: boolean;
}

export function BackupLocalFolder({ localRoot, externalEnabled }: Props) {
  return (
    <>
      <div className="flex items-start gap-2 rounded-xl bg-surface-low px-3 py-2.5 text-sm">
        <FolderOpen className="mt-0.5 size-4 shrink-0 text-on-surface-variant" aria-hidden />
        {localRoot ? (
          <span className="min-w-0 text-on-surface">
            Папка копий на сервере: <span className="break-all font-mono text-xs">{localRoot}</span>
          </span>
        ) : (
          <span className="text-on-surface-variant">Папка задаётся при установке (ниже).</span>
        )}
      </div>
      <NoticeStrip tone="warning">
        {externalEnabled
          ? "Копия на том же диске не защищает от его отказа — для надёжности выберите внешнее хранилище."
          : "Копия на том же диске не защищает от его отказа."}
      </NoticeStrip>
    </>
  );
}
